var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJpgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m396.575 0h-272.769c-10.337 0-18.806 8.439-18.806 18.777v474.417c0 10.338 8.468 18.806 18.806 18.806h336.34c10.337 0 18.776-8.469 18.776-18.806v-410.844l-56.562-27.625z",
    fill: "#f9f3f1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m396.575 62.259c0 11.038 9.052 20.091 20.091 20.091h62.257l-82.348-82.35z",
    fill: "#375e7d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m447.794 82.35v410.844c0 10.338-8.439 18.806-18.776 18.806h31.129c10.337 0 18.776-8.469 18.776-18.806v-410.844z",
    fill: "#dddaec",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m416.49 180.907h-249.057c-5.928 0-10.775 4.848-10.775 10.746v215.628l49.847-49.76c5.957-5.957 15.739-5.957 21.697 0l39.393 39.306 38.954-38.897c14.309-14.864 33.99-13.55 46.605 0l74.113 71.633v-237.91c-.001-5.928-4.849-10.746-10.777-10.746z",
    fill: "#b1e4f9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m206.504 335.59-49.847 49.76v55.367c0 5.928 4.847 10.776 10.775 10.776h23.419l58.169-21.931 18.572-54.666-39.392-39.306c-5.957-5.957-15.739-5.957-21.696 0z",
    fill: "#7fdbae",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m267.593 374.896-76.741 76.597h225.638c5.928 0 10.775-4.848 10.775-10.776v-33.086l-74.113-71.662c-12.615-13.521-32.297-14.835-46.605 0z",
    fill: "#7fdbae",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m360.57 451.493h55.92c5.928 0 10.775-4.848 10.775-10.776v-33.086l-37.056-35.831c2.278 19.508-10.775 58.785-29.639 79.693z",
    fill: "#26bb9e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m190.852 451.493 76.741-76.597-27.216-27.158c-7.184 40.591-37.027 83.927-80.742 100.397 1.956 2.073 4.731 3.358 7.797 3.358z",
    fill: "#26bb9e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m390.209 191.653v180.148l37.056 35.831v-215.979c0-5.928-4.847-10.746-10.775-10.746h-37.056c5.928 0 10.775 4.818 10.775 10.746z",
    fill: "#75cef8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m245.02 237.676c-13.52-1.256-25.522 8.673-26.778 22.223-1.256 13.521 8.702 25.493 22.222 26.749 13.549 1.256 25.522-8.702 26.778-22.223s-8.701-25.494-22.222-26.749z",
    fill: "#fec165",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m247.999 264.425c-.847 9.345-6.804 16.966-14.863 20.383 2.278.964 4.731 1.606 7.33 1.84 13.549 1.256 25.522-8.702 26.778-22.223s-8.702-25.493-22.222-26.749c-4.205-.409-8.264.292-11.885 1.84 9.576 4.059 15.884 13.987 14.862 24.909z",
    fill: "#fdb441",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m46.16 65.646h282.58c7.213 0 13.111 5.899 13.111 13.112v115.377c0 7.213-5.899 13.112-13.111 13.112h-282.58c-7.213 0-13.082-5.899-13.082-13.112v-115.377c-.001-7.213 5.869-13.112 13.082-13.112z",
    fill: "#fec165",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m302.342 78.758v115.377.029c0 7.184-5.899 13.083-13.082 13.083h39.48c7.213 0 13.082-5.899 13.111-13.083 0 0 0 0 0-.029v-115.377c0-7.213-5.899-13.112-13.111-13.112h-39.48c7.184 0 13.082 5.899 13.082 13.112z",
    fill: "#fdb441",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m260.146 176.777c-23.614 0-42.826-19.212-42.826-42.827s19.212-42.827 42.826-42.827c8.604 0 16.887 2.529 23.955 7.314 3.534 2.392 4.459 7.196 2.066 10.73-2.393 3.532-7.197 4.457-10.729 2.066-4.501-3.047-9.788-4.658-15.292-4.658-15.094 0-27.373 12.28-27.373 27.374 0 15.095 12.28 27.374 27.373 27.374 13.305 0 19.75-9.42 21.802-19.648h-12.516c-4.267 0-7.726-3.459-7.726-7.726 0-4.268 3.459-7.726 7.726-7.726h20.996c4.267 0 7.726 3.459 7.726 7.726.001 25.217-15.629 42.828-38.008 42.828z",
    fill: "#2b4d66"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m172.776 93.634h-19.536c-4.205 0-7.726 3.52-7.726 7.726v70.202c0 4.268 3.459 7.726 7.726 7.726s7.726-3.459 7.726-7.726v-22.833c4.182-.022 9.077-.044 11.809-.044 15.402 0 27.934-12.348 27.934-27.526.001-15.177-12.53-27.525-27.933-27.525zm0 39.598c-2.71 0-7.54.022-11.706.043-.022-4.301-.044-9.335-.044-12.117 0-2.346-.016-7.573-.031-12.072h11.782c6.765 0 12.481 5.528 12.481 12.072s-5.717 12.074-12.482 12.074z",
    fill: "#2b4d66"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m99.012 179.314c-7.319 0-13.595-4.033-16.84-7.301-3.007-3.028-2.989-7.921.038-10.928 3.011-2.989 7.863-2.99 10.875-.013.271.259 4.524 4.212 8.298 2.107 2.003-1.119 3.249-3.312 3.249-5.721v-56.098c0-4.268 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v56.098c0 8.004-4.281 15.367-11.172 19.214-3.386 1.889-6.74 2.642-9.9 2.642z",
    fill: "#2b4d66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpgFile);
export default __webpack_public_path__ + "static/media/jpg-file.35d6db70cdeaf4ff8f222673cf20242a.svg";
export { ForwardRef as ReactComponent };